import { PaymentData } from '../../../types';

export function cleanInvoiceData(data: any): PaymentData {
  // Clean and validate date format
  let dueDate = data.dueDate;
  if (dueDate) {
    try {
      // Handle various date formats
      const date = new Date(dueDate);
      if (!isNaN(date.getTime())) {
        dueDate = date.toISOString().split('T')[0];
      } else {
        dueDate = undefined;
      }
    } catch {
      dueDate = undefined;
    }
  }

  return {
    name: String(data.name || '').trim(),
    iban: String(data.iban || '').replace(/\s+/g, '').toUpperCase(),
    amount: typeof data.amount === 'number' ? data.amount : 
            typeof data.amount === 'string' ? parseFloat(data.amount.replace(/[^\d.,]/g, '').replace(',', '.')) : 0,
    currency: String(data.currency || 'EUR').toUpperCase(),
    reference: data.reference ? String(data.reference).trim() : undefined,
    dueDate
  };
}